import { useState } from "react";
import SciensHaloLogo from "../utils/SciensHaloLogo.svg";
import { cancelIcon, hamburgerIcon } from "../utils/svg";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../utils/Button";
import { forceLogout } from "../network/api";

export const Navbar = ({ homeRoute, showOptions = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <div className="flex justify-between items-center px-5 py-4">
      <img
        src={SciensHaloLogo}
        alt="SciensLogistics Halo Logo"
        onClick={() => {
          navigate(homeRoute);
        }}
        className="h-14"
      />
      {location.pathname !== "/login" && showOptions ? (
        <button
          onClick={() => {
            setOpenMenu(!openMenu);
          }}
        >
          <div
            className={`fixed top-0 right-0 border w-64 z-10 bg-white flex flex-col justify-between shadow-lg transform transition-transform duration-300 ease-in-out ${openMenu ? "translate-x-0" : "translate-x-full"
              }`}
          >
            <div className="">
              <div className=" text-right p-4">
                <button onClick={() => setOpenMenu(!openMenu)}>
                  {cancelIcon()}
                </button>
              </div>

              <ul>
                <li
                  className="py-2 text-left hover:bg-gray-200 cursor-pointer p-4"
                  onClick={() => {
                    navigate(homeRoute);
                  }}
                >
                  Home
                </li>
                <li
                  className="py-2 text-left hover:bg-gray-200 cursor-pointer p-4"
                  onClick={() => navigate("/documents")}
                >
                  Assignment docs
                </li>
                <li
                  className="py-2 text-left hover:bg-gray-200 cursor-pointer p-4"
                  onClick={() => navigate("/profile")}
                >
                  Profile
                </li>
                <li
                  className="py-2 text-left hover:bg-gray-200 cursor-pointer p-4"
                  onClick={() => navigate("/bank_details")}
                >
                  Bank Details
                </li>
              </ul>
            </div>
            <div className=" p-4 border-t border-gray-200">
              <Button
                text={"Logout"}
                size={"md"}
                onClick={() => forceLogout()}
              />
            </div>
          </div>
          {hamburgerIcon()}
        </button>
      ) : (
        <></>
      )}
    </div>
  );
};
